import { EVENTS } from '../../../../../library';

export const TRANSLATION_PATH = (route) => {
  return `views.app.reports.devices.${route}`;
};

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.VIEWS.APP.REPORTS.DEVICES[event];
};
